import lodash from 'lodash';
import {createSelector} from 'reselect/lib/index';

export const getState = (state, param = null, defaultValue = null) => lodash.get(state, 'shippingUser' + (param ? '.' + param : ''), defaultValue);

export const shippingUsersSuggestActive = createSelector(
    state => getState(state, 'list.usersSuggest', []),
    shippingUsersSuggest => shippingUsersSuggest.filter(shippingUser => shippingUser.shipping_user.active)
);
